import { environment } from './../../../../environments/environment';
import { EntidadeSerializer } from './entidade.serializer';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ResourceService } from '../../../common/resource.service';
import { Entidade } from './entidade';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EntidadeService extends ResourceService<Entidade> {

  urlAdmin: string = environment.apiAdmin;

  constructor(http: HttpClient) {
    super(http, 'entidade', new EntidadeSerializer(Entidade));
  }

  buscarTodas(): Observable<Entidade[]> {
    return this.httpClient.get<Entidade[]>(`${this.urlAdmin}/entidade/todos`).pipe(
      map(data => this.convertData(data))
    )

  }

  getImagem(id):Observable<any>{
    return this.httpClient.get<any>(`${this.urlAdmin}/entidade/imagem/${id}`).pipe(
      take(1),
      map(img => img.path)
    );
  }
}
